import { Icon } from '@natera/material/lib/icon'
import { useEffect } from 'react'
import { Button } from '~/shared/ui'
import {
  useFilterListVisibilityStore,
  useFilters,
  useInitializeDefaultPinnedFilters,
} from '../../model'
import { FilterChips } from './filter-chips'
import { SearchField } from './search-field'
import { Settings } from './settings'

export function ActionsBar() {
  useInitializeDefaultPinnedFilters()
  const { filtersFormVisible, setFiltersFormVisible } = useFilterListVisibilityStore()
  const { resetFilters, isDirty } = useFilters()

  useEffect(() => {
    return () => {
      setFiltersFormVisible(false)
    }
  }, [setFiltersFormVisible])

  return (
    <div className="flex flex-wrap gap-x-2 gap-y-3 px-6 py-3">
      <div className="flex w-full items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-[240px]">
            <SearchField />
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <FilterChips mode="pinned" />
            <Button
              className="text-content-high-emphasis px-2"
              onClick={() => setFiltersFormVisible(!filtersFormVisible)}
            >
              <Icon
                className="m-0"
                children="tune"
              />
            </Button>
          </div>
        </div>

        <div className="flex items-center gap-3">
          {isDirty && (
            <Button
              size="small"
              onClick={resetFilters}
            >
              Clear filters
            </Button>
          )}
          <Settings />
        </div>
      </div>

      <FilterChips mode="unpinned" />
    </div>
  )
}
